export const positiveFiniteResolution = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const resolution = Number(value);
  return Number.isFinite(resolution) && resolution > 0 ? resolution : null;
};

export const resolveDesignResolution = (...candidates) => {
  for (const candidate of candidates) {
    const resolution = positiveFiniteResolution(candidate);
    if (resolution !== null) return resolution;
  }
  return null;
};
